import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Select } from 'shared/ui/Select';
import { NotifiedAboutLeaveFilter, ContractsListFilterKeys } from '../../model/types';

interface PlannedDepartureSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const PlannedDepartureSelect: FC<PlannedDepartureSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'common']);

  const invoiceTypeOptions = useMemo<Array<{ label: string; value: NotifiedAboutLeaveFilter }>>(() => {
    return [
      { label: t('Notified'), value: NotifiedAboutLeaveFilter.NOTIFIED },
      { label: t('Unnotified'), value: NotifiedAboutLeaveFilter.UNNOTIFIED },
    ];
  }, [t]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(ContractsListFilterKeys.isNotified);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Planned departure')}
      placeholder={t('All')}
      bordered
      allowClear
      options={invoiceTypeOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
